<template>
  <field-frame :field="field" :show-optional="showOptional">
    <template #default="{ inputId, describedBy, requiredEmpty }">
      <textarea
        :id="inputId"
        class="field-input min-h-[6rem] resize-y"
        :rows="field.rows || 4"
        :placeholder="placeholder"
        :maxlength="field.maxlength || undefined"
        :readonly="field.readonly === true"
        :aria-required="field.required ? 'true' : 'false'"
        :aria-invalid="requiredEmpty ? 'true' : 'false'"
        :aria-describedby="describedBy"
        v-model="field.text"
      ></textarea>
      <div v-if="instantTexts.length" class="flex flex-wrap gap-1.5 mt-2" role="group" :aria-label="$t('よく使う表現を追加')">
        <button
          v-for="(t, i) in instantTexts"
          :key="i"
          type="button"
          class="text-sm px-3 py-1.5 rounded-full bg-q4cl-surface border border-q4cl-border text-q4cl-ink hover:bg-white min-h-[36px]"
          @click="insert(t)"
        >+ {{ $t(t) }}</button>
      </div>
    </template>
  </field-frame>
</template>

<script>
import FieldFrame from '@/components/ui/FieldFrame.vue'
export default {
  name: 'TextareaField',
  components: {
    'field-frame': FieldFrame
  },
  props: {
    field: { type: Object, required: true },
    showOptional: { type: Boolean, default: false }
  },
  setup(props) {
    const i18n = window.i18nStore;
    const placeholder = Vue.computed(() => (i18n ? i18n.i18n(props.field.placeholder || '') : ''));
    const instantTexts = Vue.computed(() => {
      const raw = props.field.instanttext;
      if (!raw) return [];
      return Array.isArray(raw) ? raw : String(raw).split('|');
    });
    function insert(t) {
      const cur = props.field.text || '';
      // 旧版踏襲 (RenderQuestionnaire.vue:826): 既に含まれていれば追加しない (連打防止)
      if (cur.indexOf(t) >= 0) return;
      props.field.text = cur + (cur.endsWith('\n') || cur === '' ? '' : '\n') + t;
    }
    return { placeholder, instantTexts, insert };
  }
};
</script>
